import KC_UIText from "../../../../designsystem/typography/KC_UIText/KC_UIText";
import React from "react";

export interface LegendI {
  name: string;
  value: number;
  color?: string;
}

interface Props {
  data: Array<LegendI>;
}

export default function Legend(props: Props) {
  return (
    <>
      {props.data.map((el, index) => (
        <div
          className="d-flex flex-row justify-content-between justify-content-sm-center align-items-start ds-gap-column-standard"
          key={`${el.color}${el.name}${index}`}
        >
          <div
            style={{
              backgroundColor: el.color,
              minWidth: 20,
              width: 20,
              maxWidth: 20,
              minHeight: 20,
              height: 20,
              maxHeight: 20,
              borderRadius: 5,
              boxShadow: "0px 4px 8px 0px #634FE847"
            }}
          />
          <KC_UIText weight="reg" text={el.name} className="flex-grow-1" />
          <div className="font-weight-bold">{el.value}</div>
        </div>
      ))}
    </>
  );
}
